import React__default from 'react';
import classnames from 'classnames';
import { getSelectionBoxStyles } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { getProductKeyFromCTType } from '@grandvisionhq/utils';
import { useAccessibleName } from './hooks/useAccessibleName.js';

const FacetLink = ({ item , isActive , className , children , onPick , productType ,  })=>{
    const accessibleName = useAccessibleName(item);
    const productLink = useLink({
        route: 'products.detail',
        params: {
            slug: item.slug,
            sku: item.sku,
            key: getProductKeyFromCTType(productType)
        }
    });
    const queryString = typeof window !== 'undefined' ? window.location.search : '';
    const href = `${productLink === null || productLink === void 0 ? void 0 : productLink.href}${queryString}`;
    const { name , facetTerm , sku  } = item;
    const selectionBoxClassnames = getSelectionBoxStyles({
        isSelected: isActive,
        isDisabled: false,
        className
    });
    return /*#__PURE__*/ React__default.createElement("a", {
        href: href,
        "data-t": "facet-picker-link",
        key: item.sku,
        title: accessibleName,
        className: `facet-link ${classnames(selectionBoxClassnames)}`,
        onClick: (event)=>onPick({
                event,
                sku,
                href,
                name,
                facetTerm
            })
    }, children);
};

export { FacetLink };
//# sourceMappingURL=FacetLink.js.map
